var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { List } from '@material-ui/core';
import { Search } from '@material-ui/icons';
import { isCapitalUI } from '../../../include/react-common/theme';
import { appUrl } from '../../../include/utils';
/** Keep the fixed header outside the scrollable options, including in picker popups. */
export function MultiSelectListFrame(_a) {
    var { subheader, children, className, style, scrollRef } = _a, props = __rest(_a, ["subheader", "children", "className", "style", "scrollRef"]);
    if (!isCapitalUI)
        return React.createElement(List, Object.assign({}, props, { ref: scrollRef, className: className, style: style, subheader: subheader }), children);
    return React.createElement("div", { className: `${className || ''} capital-multiselect-list`, style: style },
        subheader ? React.createElement("div", { className: "capital-multiselect-heading" }, subheader) : null,
        React.createElement(List, Object.assign({}, props, { ref: scrollRef, disablePadding: true, className: "capital-multiselect-options" }), children));
}
export function MultiSelectSearchIcon() {
    return isCapitalUI ? React.createElement("img", { src: appUrl('/Content/capital/assets/list-search.svg'), alt: "" }) : React.createElement(Search, { htmlColor: "#fff" });
}
